import React, { useEffect, useState } from "react";
import css from "./Style.module.css";
import PdfDoc from "./PdfDoc";
import { PDFViewer } from "@react-pdf/renderer";
import { Get } from "../../Services/Server";
import Url from "../../Services/Url";

const ViewReportModal = ({ children }) => {
	const { survey, closeModal } = children;
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);
	const [equipmentMap, setEquipmentMap] = useState({});

	useEffect(() => {
		if (!survey?.jobNumber) return;

		setLoading(true);

		Get(Url.survey.getEquipments)
			.then((equipments) => {
				const map = {};
				(equipments || []).forEach((eq) => {
					map[eq.id] = eq.description;
				});
				setEquipmentMap(map);
			})
			.catch((err) => console.error("Error fetching equipments:", err));
	}, [survey?.jobNumber]);

	useEffect(() => {
		if (!survey?.jobNumber || Object.keys(equipmentMap).length === 0) return;

		Get(Url.survey.getReportByJobId(survey.jobNumber))
			.then((resp) => {
				if (resp) {
					const equipmentIds = resp.equipments
						? JSON.parse(resp.equipments)
						: [];
					const equipmentList = equipmentIds.map((id) => ({
						item: equipmentMap[id] || `Unknown (${id})`,
					}));

					const transformed = {
						feasibilitySummary: { summary: resp.description || "" },
						requiredMaterials: equipmentList,
						photos: resp.docId ? [Url.img.get(resp.docId)] : [],
					};

					setReport(transformed);
				} else {
					setReport(null);
				}
			})
			.catch((err) => console.error("Error fetching report:", err))
			.finally(() => setLoading(false));
	}, [survey?.jobNumber, equipmentMap]);

	if (loading) {
		return <div className={css.Modal}>Loading report...</div>;
	}

	if (!report) {
		return <div className={css.Modal}>No report found for this survey.</div>;
	}

	return (
		<div className={css.Modal}>
			<div style={{ width: "100%", height: "80vh" }}>
				<PDFViewer style={{ width: "100%", height: "100%" }}>
					<PdfDoc report={report} survey={survey} logo={children.logo} />
				</PDFViewer>
			</div>
		</div>
	);
};

export default ViewReportModal;
